<template>
  <div>
    <vue-snotify></vue-snotify>
    <b-row style="text-align:center;display:none;">
      <b-col cols="3"></b-col>
      <b-col cols="5">
        <h1 class="h1"> 
          <strong>Role {{ action_type }}</strong>
        </h1>
        <h4 class="small-text">{{ action_type }} the Role here</h4>
      </b-col>
      <b-col cols="4"></b-col>
    </b-row>
    <ValidationObserver ref="form" v-slot="{ passes }">
      <b-form action="#" @submit.prevent="passes(submitRole)">
        <!-- role name -->
        <ValidationProvider
          vid="name"
          name="Role Name"
          v-slot="{ errors }"
          rules="required"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Role Name</span>
            </b-col>
            <b-col cols="5">
              <input
                id="role_name"
                type="text"
                placeholder="Role Name"
                class="form-control form-control-lg"
                v-model="roleData.role_name"
                data-vv-as="Role Name"
              />
            </b-col>
            <b-col cols="4">
              <div v-if="!errors[0]" class="color-box color-box-user-id">
                <p>
                  <span style="color:red">*</span>The Role Name field is
                  required
                </p>
              </div>
              <div v-else class="color-box-v color-box-user-id-v">
                <p v-for="(error, index) in errors" v-bind:key="index">
                  {{ error }}
                </p>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <!-- Permission -->
        <ValidationProvider
          vid="permissions"
          name="Permissions"
          v-slot="{ errors }"
          rules="required"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Permissions</span>
            </b-col>
            <b-col cols="5" class="permissions">
              <b-row
                class="row"
                v-for="(permission, index) in permissionList"
                v-bind:key="index"
              >
                <b-col cols="2">
                  <div class="toggle-button-cover">
                    <!--<div class="button-cover">-->
                    <div class="button r" id="button-1">
                      <input
                        type="checkbox"
                        :value="permission.name"
                        class="checkbox"
                        v-model="roleData.permissions"
                      />
                      <div class="knobs"></div>
                      <div class="layer"></div>
                    </div>
                    <!--</div>-->
                  </div>
                </b-col>
                <b-col cols="10">
                  <div class="permission">
                    <strong>{{ permission.description }}</strong>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="4">
              <div v-if="!errors[0]" class="color-box color-box-user-id">
                <p>
                  <span style="color:red">*</span>The Permissions field is
                  required
                </p>
              </div>
              <div v-else class="color-box-v color-box-user-id-v">
                <p v-for="(error, index) in errors" v-bind:key="index">
                  {{ error }}
                </p>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <ValidationProvider
          vid="status"
          name="Status"
          v-slot="{ errors }"
          rules="required"
        >
          <b-row class="row-top">
            <b-col cols="3">
              <span class="span">Status</span>
            </b-col>
            <b-col cols="5">
              <select
                v-model="roleData.role_status"
                class="form-control form-control-lg"
              >
                <option value="">--PLEASE SELECT--</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </b-col>
            <b-col cols="4">
              <div v-if="!errors[0]" class="color-box color-box-user-id">
                <p>
                  <span style="color:red">*</span>The Status field is required
                </p>
              </div>
              <div v-else class="color-box-v color-box-user-id-v">
                <p v-for="(error, index) in errors" v-bind:key="index">
                  {{ error }}
                </p>
              </div>
            </b-col>
          </b-row>
        </ValidationProvider>

        <!-- Create -->
        <b-row class="row-top row-bottom">
          <b-col cols="3">
            <span class="span"></span>
          </b-col>
          <b-col cols="5">
            <b-row>             
              <b-col cols="6">
                <b-button type="submit" block variant="primary" size="lg">{{
                  btn_label
                }}</b-button>
              </b-col>
               <b-col cols="6">
                <router-link to="/roles">
                  <b-button block size="lg">Cancel</b-button>
                </router-link>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="4">
            <div></div>
          </b-col>
        </b-row>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { extend } from "vee-validate/dist/vee-validate.full";
import router from "@/router";

export default {
  name: "RoleCreate",
  data() {
    return {
      // selected_system_role : "",
      permissionList: [],
      //  selectedData:[],
      system_role_list: [],
      action_type: "Creation",
      btn_label:"Save"
      //role_status:""
    };
  },
  async created() {
    this.resetRoleData();
    if (this.$route.params.role_id) {
      this.findRole(this.$route.params.role_id);
      this.action_type = "Edit";
      this.btn_label = "Update";
    }
  },
  computed: {
    ...mapState("role", [
      "roleData",
      "permissions_list",
      "sysRoles",
      "permissions",
      "errors"
    ])
  },
  methods: {
    ...mapActions("role", [
      "getRoleData",
      "insertRoleData",
      "getRoleList",
      "getSystemRoles",
      "updateRoleData",
      "resetRoleData"
    ]),

    async findRole(role_id) {
      await this.getRoleData(role_id);
    },

    async clearData() {
      await this.resetRoleData();
    },

    async PermissionList() {
      await this.getRoleList();
      this.permissionList = this.permissions_list;
    },

    async SystemRoleList() {
      await this.getSystemRoles(); 
      this.system_role_list = this.sysRoles;
    },

    async submitRole() {
      const roleInfo = {
        role_name: this.role_name,
        permissions: this.selectedData,
        role_status: this.role_status,
        system_role_id: this.selected_system_role
      };
      this.$snotify.clear();
      if (this.$route.params.role_id) {
        roleInfo.role_id = this.$route.params.role_id;
        await this.updateRoleData(roleInfo).then(response => {
          if (response.data.success) {
            this.$refs.form.reset();
            this.$snotify
              .success(response.data.success.message, "", {
                position: "centerTop"
              })
              .on("destroyed", () => this.$router.push("/roles"));

            // router.push('/roles');
          } else {
            this.$snotify.error(response.data.error.message, "Error!", {
              position: "centerTop"
            });
          }
        });
      } else {
        await this.insertRoleData(roleInfo).then(response => {
          if (response.data.success) {
            this.clearData().then(() => {
              this.$refs.form.reset();
              this.$snotify
                .success(response.data.success.message, "", {
                  position: "centerTop"
                })
                .on("destroyed", () => this.$router.push("/roles"));
            });
            // router.push('/roles');
          } else {
            this.$snotify.error(response.data.error.message, "Error!", {
              position: "centerTop"
            });
          }
        });
      }
      this.$refs.form.setErrors(this.errors);
    }
  },
  mounted() {
    this.PermissionList();
  }
};
</script>

<style scoped>
.small-text {
  color: #73818f;
}

.h1 {
  margin-bottom: 0rem !important;
}

.row-top {
  margin-top: 30px;
}

.row-bottom {
  margin-bottom: 50px;
}

.span {
  float: right;
  margin-top: 12px;
  color: #73818f;
  font-weight: 400;
}

.permission {
  margin-top: 12px;
  color: #73818f;
  font-weight: 400;
  margin-left: 12px;
}

::placeholder {
  color: #73818f;
  font-weight: 200;
  font-size: 14px;
  font-style: italic;
}

.role-row {
  margin-bottom: 20px;
}

/* ---- start toggle css ----- */

* {
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

*:focus {
  outline: none;
}

.toggle-button-cover {
  display: table-cell;
  position: relative;
  /*width: 200px;*/
  height: 50px;
  box-sizing: border-box;
}

.button-cover {
  height: 100px;
  margin: 20px;
  background-color: #fff;
  box-shadow: 0 10px 20px -8px #c5d6d6;
  border-radius: 4px;
}

.button-cover:before {
  counter-increment: button-counter;
  content: counter(button-counter);
  position: absolute;
  right: 0;
  bottom: 0;
  color: #d7e3e3;
  font-size: 12px;
  line-height: 1;
  padding: 5px;
}

.button-cover,
.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.button {
  position: relative;
  top: 50%;
  width: 74px;
  height: 36px;
  margin: -20px auto 0 auto;
  overflow: hidden;
}

.button.r,
.button.r .layer {
  border-radius: 100px;
}

.button.b2 {
  border-radius: 2px;
}

.checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.knobs {
  z-index: 2;
}

.layer {
  width: 100%;
  background-color: #fcebeb;
  transition: 0.3s ease all;
  z-index: 1;
}

/* Button 1 */
#button-1 .knobs:before {
  content: "NO";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 30px;
  height: 30px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  background-color: #f44336;
  line-height: 1;
  padding: 9px 4px;

  border-radius: 50%;
  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
}

#button-1 .checkbox:checked + .knobs:before {
  content: "YES";
  left: 42px;
  background-color: #03a9f4;
}

#button-1 .checkbox:checked ~ .layer {
  background-color: #ebf7fc;
}

#button-1 .knobs,
#button-1 .knobs:before,
#button-1 .layer {
  transition: 0.3s ease all;
}

/* ---- end of toggle css ---- */

.container {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.wrapper {
  margin: 0px !important;
}

.wrapper .container .bottom .left .details {
  padding: 10px 0 0 18px !important;
  width: calc(70% - 0px) !important;
}

.wrapper .container .bottom .left .add i {
  padding: 9px !important;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: #ffffff;
  margin-top: 25px;
}

.wrapper .container .bottom .right .done i {
  padding: 10px !important;
}

.wrapper .container .bottom .right .details {
  padding: 10px !important;
  float: right;
  width: calc(70% - 4px) !important;
}

.wrapper .container .bottom .right .remove i {
  padding: 12px !important;
}

.wrapper .container .bottom .right .remove {
  height: 58% !important;
}

.permissions {
  overflow-y: scroll;
  height: 300px;
}
</style>
